import Row from './Row';
import RowColumn from './RowColumn';

export { Row, RowColumn };

export default {
  Row,
  RowColumn,
};
